import { render, staticRenderFns } from "./PortfolioInformation.vue?vue&type=template&id=a83628fc&scoped=true&"
import script from "./PortfolioInformation.vue?vue&type=script&lang=ts&"
export * from "./PortfolioInformation.vue?vue&type=script&lang=ts&"
import style0 from "./PortfolioInformation.vue?vue&type=style&index=0&id=a83628fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83628fc",
  null
  
)

export default component.exports